// extracted by mini-css-extract-plugin
module.exports = {"rating":"reviews_rating__Qqq0a"};